import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Breadcrumb from 'components/common/Breadcrumb';
import Panel from './Panel';
import Rows from './Rows';
import startCase from 'lodash/startCase';
import './Curated.css';
import { SmallScreen } from 'utils/responsive-mq';
import MyHelmet from 'components/common/MyHelmet';

const Curated = (props) => {
	return (
		<div id="Page_Curated" className="Page">
			<MyHelmet
				title={props.breadcrumb[0].title}
			/>{/* TODO: BAD */}

			<div className="wrap">
				<Breadcrumb items={props.breadcrumb} />
				{ props.items && 
					<SmallScreen>
						{ match => {
							return (match)
								? <Rows items={props.items} />
								: <Panel items={props.items} />
						} }
					</SmallScreen>
				}
				{ !props.items && props.loaded && 
					<h5>No result.</h5>
				}
			</div>
		</div>
	)
}
Curated.propTypes = {
	loaded: PropTypes.bool,
	items: PropTypes.array,
	breadcrumb: PropTypes.array,
}
const mapStateToProps = (state, ownProps) => {
	const { term } = ownProps.match.params;

	const curated = get( state.fetcher, ['archives', 'curated'] );
	const status = curated ? curated.status : null;
	const match = get( curated, 'data', [] ).find( el => el.slug === term );
	const projects = get( match, 'associatedProjects', [] ).filter( p => p.coverImage || p.coverImageAlt );
	const items = projects.map( p => {
		const cover = p.coverImageAlt || p.coverImage;
		return {
			slug: p.slug,
			title: p.title,
			row2: p.row2,
			year: get( p, ['year', 'title'] ),
			client: get( p, ['client', 'title'] ),
			src: cover.src,
			hex: p.prominentColorOfCoverImage || '#f9f9f9',
			width: cover.width,
			height: cover.height,
		}
	} );
	const title = get( match, 'title', term );
	const breadcrumb = [{title: '#'+startCase(title)}];
	return {
		key: ownProps.location.key,
		loaded: (status === 'success' || status === 'error'),
		items: (items.length > 0)? items : null,
		breadcrumb: breadcrumb,
	}
}
export default connect(mapStateToProps)(Curated);


// WEBPACK FOOTER //
// ./src/components/Pages/Curated/Curated.jsx